import React from "react"
import CarMake from "../pages/Master/carmake"
import Currency from "../pages/Master/Currency"
import Paytype from "../pages/Master/Paytype"
import Country from "../pages/Master/Country"
import Designation from "../pages/Master/Designation"
import CarModel from "../pages/Master/CarModel"
import BranchType from "../pages/Master/BranchType"
import BranchArea from "../pages/Master/BranchArea"
import ItemAdd from "../pages/Master/ItemAdd"
import Itemlist from "../pages/Master/itemlist"
import ItemName from "../pages/Master/ItemName"
import ItemGroup from "../pages/Master/ItemGroup"
import ItemUnit from "../pages/Master/ItemUnit"
import ItemOem from "../pages/Master/ItemOem"
import VendorGroup from "../pages/Master/VendorGroup"
import VendorLocation from "../pages/Master/VendorLocation"
import Department from "../pages/Master/Department"
import Business from "../pages/Master/Business"
import BranchAdd from "../pages/Master/BranchAdd"
import Login from "../pages/Master/Login"
import Logout from "../pages/Master/Logout"
import SalesCustomer from "../pages/Sales/SalesCustomer"
import Employee from "../pages/Master/Employee"
import Card from "../pages/Workshop/Card"
import Dashboard from "../pages/Master/DashBoard"
import DefaultDashboard from "../pages/Master/DefaultDashboard"
import SalesToJobCard from "../pages/Sales/SalesToJobCard"
import Vendor from "../pages/Master/Vendor"
import PurchaseBranch from "../pages/Workshop/PurchaseBranch"
import ComingSoon from "../pages/ComingSoon/ComingSoon"


//////
import EmployeePage from "../pages/GMS/EmployeePage";
import AddEmployeePage from "../pages/GMS/AddEmployeePage";
import BusinessPage from "../pages/GMS/BusinessPage";
import BranchPage from "../pages/GMS/BranchPage";
import RestaurantTablePage from "../pages/GMS/RestaurantTablePage";
import RestaurantBookingListPage from "../pages/GMS/RestaurantBookingListPage";
import CompanyPage from "../pages/GMS/CompanyPage";
import DepartmentPage from "../pages/GMS/DepartmentPage";
import DesignationPage from "../pages/GMS/DesignationPage";
import UserManagementPage from "../pages/GMS/UserManagementPage";
import RoleManagementPage from "../pages/GMS/RoleManagementPage";
import LeaveTypePage from "../pages/GMS/LeaveTypePage";
import EmployeeLeavePage from "../pages/GMS/EmployeeLeavePage";
import EmployeeLeaveCreditPage from "../pages/GMS/EmployeeLeaveCreditPage";
import SalaryAdvancePage from "../pages/GMS/SalaryAdvancePage";
import AbsentDaysPage from "../pages/GMS/AbsentDaysPage";
import DailyAttendancePage from "../pages/GMS/DailyAttendancePage";
import PayrollProcessingPage from "../pages/GMS/PayrollProcessingPage";
import PermissionGuard from "../components/Permission/PermissionGuard";
import SalaryAdvanceTransactionReport from "../pages/GMS/SalaryAdvanceTransactionReport";
import PayrollHistoryReportPage from "../pages/GMS/PayrollHistoryReportPage";
import PayrollDetailsHistoryReportPage from "../pages/GMS/PayrollDetailsHistoryReportPage";
import ActivityManagementPage from "../pages/GMS/ActivityManagementPage";
import ProductManagementPage from "../pages/GMS/ProductManagementPage";
import AddProductPage from "../pages/GMS/AddProductPage";
import DaybookPage from "../pages/GMS/DaybookPage";
import AddDaybookPage from "../pages/GMS/AddDaybookPage";
import SalesbookPage from "../pages/GMS/SalesbookPage";
import ExpiringDocumentsPage from "../pages/GMS/ExpiringDocumentsPage";
import NotificationsPage from "../pages/GMS/NotificationsPage";
import GroupPage from "../pages/GMS/GroupPage";
import ServicePage from "../pages/GMS/ServicePage";
import ActivityUpdatedPage from "../pages/GMS/ActivityUpdatedPage";
import SalaryRevisionPage from "../pages/GMS/SalaryRevisionPage";
import AnnualLeaveCreditPage from "../pages/GMS/AnnualLeaveCreditPage";
import CustomerPage from "../pages/GMS/CustomerPage";
import CustomerListPage from "../pages/GMS/CustomerListPage";
import RoomPage from "../pages/GMS/RoomPage";
import EquipmentPage from "../pages/GMS/EquipmentPage";
import BookingPage from "../pages/GMS/BookingPage";
import AddBookingPage from "../pages/GMS/AddBooking";
import TaxPage from "../pages/GMS/TaxPage";
import SpaCategoryPage from "../pages/GMS/SpaCategoryPage";
import SpaSubCategoryPage from "../pages/GMS/SpaSubCategoryPage";
import SpaServicePage from "../pages/GMS/SpaServicePage";
import SpaPackagesPage from "../pages/GMS/SpaPackagesPage";
import SpaPackageSeriesPage from "../pages/GMS/SpaPackageSeriesPage";
import SpaCalendarPage from "../pages/GMS/SpaCalendarPage";
import SpaEmployeeDashboard from "../pages/GMS/SpaEmployeeDashboard";
import SpaManagerFinanceDashboard from "../pages/GMS/SpaManagerFinanceDashboard";
import AdminDashboard from "../pages/GMS/AdminDashboard";
import MembershipPage from "../pages/GMS/MembershipPage";
import BillingPage from "../pages/GMS/BillingPage";
import InvoiceListPage from "../pages/GMS/InvoiceListPage";
import CustomerReceiptsPage from "../pages/GMS/CustomerReceiptsPage";
import AddReceiptPage from "../pages/GMS/AddReceiptPage";
import CashDepositPage from "../pages/GMS/CashDepositPage";
import AddCashDepositPage from "../pages/GMS/AddCashDepositPage";
import BankPage from "../pages/GMS/BankPage";
import BankAccountPage from "../pages/GMS/BankAccountPage";
import DayClosingPage from "../pages/GMS/DayClosingPage";
import ZReportPage from "../pages/GMS/ZReportPage";
import InvoiceReportPage from "../pages/GMS/InvoiceReportPage";
import TaxInvoiceReportPage from "../pages/GMS/TaxInvoiceReportPage";
import BookingReportPage from "../pages/GMS/BookingReportPage";
import EmployeeReportPage from "../pages/GMS/EmployeeReportPage";
import DailySummaryReportPage from "../pages/GMS/DailySummaryReportPage";
import SupplierPage from "../pages/GMS/SupplierPage";
import SupplierCategoryPage from "../pages/GMS/SupplierCategoryPage";
import PurchasePage from "../pages/GMS/PurchasePage";
import PurchaseRequestPage from "../pages/GMS/PurchaseRequestPage";
import AddPurchaseOrderPage from "../pages/GMS/AddPurchaseOrderPage";
import AddPurchasePage from "../pages/GMS/AddPurchasePage";
import StockReportPage from "../pages/GMS/StockReportPage";
import StockTransferPage from "../pages/GMS/StockTransferPage";
import ReceiveStockTransferPage from "../pages/GMS/ReceiveStockTransferPage";
import StockLockManagementPage from "../pages/GMS/StockLockManagementPage";
import PriceCatalogPage from "../pages/GMS/PriceCatalogPage";
import ConsentFormPage from "../pages/GMS/ConsentFormPage";
import SourcePage from "../pages/GMS/SourcePage";
import CostHeadPage from "../pages/GMS/CostHeadPage";
import OtherPayeePage from "../pages/GMS/OtherPayeePage";
import PettyCashPage from "../pages/GMS/PettyCashPage";
import PettyCashReportPage from "../pages/GMS/PettyCashReportPage";
import SourceBasedReportPage from "../pages/GMS/SourceBasedReportPage";
import LoyaltyPointsPage from "../pages/GMS/LoyaltyPointsPage";
import GiftCardPage from "../pages/GMS/GiftCardPage";
import BilledServicesReportPage from "../pages/GMS/BilledServicesReportPage";
import MessageTemplatePage from "../pages/GMS/MessageTemplatePage";
import CustomerSegregationReportPage from "../pages/GMS/CustomerSegregationReportPage";
import GmsWhatsAppTest from "../pages/GMS/GmsWhatsAppTest";
import CampaignReportPage from "../pages/GMS/CampaignReportPage";
import CampaignPage from "../pages/GMS/CampaignPage";

const wrapWithPermissionGuard = (Component) => (
  <PermissionGuard>
    <Component />
  </PermissionGuard>
);

const authProtectedRoutes = [
  { path: "/carMake", element: <CarMake /> }, // Use `element` instead of `component`
  { path: "/Currency", element: <Currency /> }, // Use `element` instead of `component`
  { path: "/Paytype", element: <Paytype /> }, // Use `element` instead of `component`
  { path: "/Country", element: <Country /> }, // Use `element` instead of `component`
  { path: "/Designation", element: <Designation /> }, // Use `element` instead of `component`
  { path: "/CarModel", element: <CarModel /> }, // Use `element` instead of `component`
  { path: "/BranchType", element: <BranchType /> }, // Use `element` instead of `component`
  { path: "/BranchArea", element: <BranchArea /> }, // Use `element` instead of `component`
  { path: "/ItemAdd", element: <ItemAdd /> }, // Use `element` instead of `component`
  { path: "/itemlist", element: <Itemlist /> }, // Use `element` instead of `component`
  { path: "/ItemName", element: <ItemName /> },
  { path: "/ItemGroup", element: <ItemGroup /> },
  { path: "/ItemUnit", element: <ItemUnit /> },
  { path: "/ItemOem", element: <ItemOem /> },
  { path: "/VendorGroup", element: <VendorGroup /> },
  { path: "/VendorLocation", element: <VendorLocation /> },
  { path: "/Department", element: <Department /> },
  { path: "/Business", element: <Business /> },
  { path: "/BranchAdd", element: <BranchAdd /> },
  { path: "/SalesCustomer", element: <SalesCustomer /> },
  { path: "/Employee", element: <Employee /> },
  { path: "/Card", element: <Card /> },
  // Old Dashboard - commented out, replaced with Admin Dashboard
  // { path: "/Dashboard", element: wrapWithPermissionGuard(Dashboard) },
  { path: "/Dashboard", element: wrapWithPermissionGuard(AdminDashboard) },
  { path: "/DefaultDashboard", element: <DefaultDashboard /> },
  { path: "/SalesToJobCard", element: <SalesToJobCard /> },
  { path: "/Vendor", element: <Vendor /> },
  { path: "/PurchaseBranch", element: <PurchaseBranch /> },



  ///GMS Routes

  { path: "/GmsEmployee", element: wrapWithPermissionGuard(EmployeePage) },
  { path: "/GmsAddEmployee", element: wrapWithPermissionGuard(AddEmployeePage) },
  { path: "/GmsBusiness", element: wrapWithPermissionGuard(BusinessPage) },
  { path: "/GmsBranch", element: wrapWithPermissionGuard(BranchPage) },
  { path: "/GmsRestaurantTable", element: wrapWithPermissionGuard(RestaurantTablePage) },
  { path: "/GmsRestaurantBookingList", element: wrapWithPermissionGuard(RestaurantBookingListPage) },
  { path: "/GmsCompany", element: wrapWithPermissionGuard(CompanyPage) },
  { path: "/GmsDepartment", element: wrapWithPermissionGuard(DepartmentPage) },
  { path: "/GmsDesignation", element: wrapWithPermissionGuard(DesignationPage) },
  { path: "/GmsUser", element: wrapWithPermissionGuard(UserManagementPage) },
  { path: "/GmsRoleManagement", element: wrapWithPermissionGuard(RoleManagementPage) },
  { path: "/GmsLeaveType", element: wrapWithPermissionGuard(LeaveTypePage) },
  { path: "/GmsEmployeeLeave", element: wrapWithPermissionGuard(EmployeeLeavePage) },
  { path: "/GmsEmployeeLeaveCredit", element: wrapWithPermissionGuard(EmployeeLeaveCreditPage) },
  { path: "/GmsAnnualLeaveCredit", element: wrapWithPermissionGuard(AnnualLeaveCreditPage) },
  { path: "/GmsLeaveCalculator", element: wrapWithPermissionGuard(ComingSoon) },
  { path: "/GmsSalaryAdvance", element: wrapWithPermissionGuard(SalaryAdvancePage) },
  { path: "/GmsAbsentDays", element: wrapWithPermissionGuard(AbsentDaysPage) },
  { path: "/GmsDailyAttendance", element: wrapWithPermissionGuard(DailyAttendancePage) },
  { path: "/GmsPayrollProcessing", element: wrapWithPermissionGuard(PayrollProcessingPage) },
  { path: "/GmsSalaryAdvanceTransactionReport", element: wrapWithPermissionGuard(SalaryAdvanceTransactionReport) },
  { path: "/GmsPayrollHistoryReport", element: wrapWithPermissionGuard(PayrollHistoryReportPage) },
  { path: "/GmsPayrollDetailsHistoryReport", element: wrapWithPermissionGuard(PayrollDetailsHistoryReportPage) },
  { path: "/GmsActivityManagement", element: wrapWithPermissionGuard(ActivityManagementPage) },
  { path: "/GmsProductManagement", element: wrapWithPermissionGuard(ProductManagementPage) },
  { path: "/GmsAddProduct", element: wrapWithPermissionGuard(AddProductPage) },
  { path: "/GmsDaybook", element: wrapWithPermissionGuard(DaybookPage) },
  { path: "/GmsAddDaybook", element: wrapWithPermissionGuard(AddDaybookPage) },
  { path: "/GmsSalesbook", element: wrapWithPermissionGuard(SalesbookPage) },
  { path: "/GmsExpiringDocuments", element: wrapWithPermissionGuard(ExpiringDocumentsPage) },
  { path: "/GmsNotifications", element: wrapWithPermissionGuard(NotificationsPage) },
  { path: "/GmsGroup", element: wrapWithPermissionGuard(GroupPage) },
  { path: "/GmsService", element: wrapWithPermissionGuard(ServicePage) },
  { path: "/GmsActivityUpdated", element: wrapWithPermissionGuard(ActivityUpdatedPage) },
  { path: "/GmsSalaryRevision", element: wrapWithPermissionGuard(SalaryRevisionPage) },
  { path: "/GmsCustomer", element: wrapWithPermissionGuard(CustomerPage) },
  { path: "/GmsCustomerList", element: wrapWithPermissionGuard(CustomerListPage) },
  { path: "/GmsRoom", element: wrapWithPermissionGuard(RoomPage) },
  { path: "/GmsEquipment", element: wrapWithPermissionGuard(EquipmentPage) },
  { path: "/GmsBooking", element: wrapWithPermissionGuard(BookingPage) },
  { path: "/GmsAddBooking", element: wrapWithPermissionGuard(AddBookingPage) },
  { path: "/GmsTax", element: wrapWithPermissionGuard(TaxPage) },
  { path: "/GmsSpaCategory", element: wrapWithPermissionGuard(SpaCategoryPage) },
  { path: "/GmsSpaSubCategory", element: wrapWithPermissionGuard(SpaSubCategoryPage) },
  { path: "/GmsSpaService", element: wrapWithPermissionGuard(SpaServicePage) },
  { path: "/GmsSpaPackages", element: wrapWithPermissionGuard(SpaPackagesPage) },
  { path: "/GmsSpaPackageSeries", element: wrapWithPermissionGuard(SpaPackageSeriesPage) },
  { path: "/GmsSpaCalendar", element: wrapWithPermissionGuard(SpaCalendarPage) },
  { path: "/GmsSpaEmployeeDashboard", element: wrapWithPermissionGuard(SpaEmployeeDashboard) },
  { path: "/GmsSpaManagerFinanceDashboard", element: wrapWithPermissionGuard(SpaManagerFinanceDashboard) },
  { path: "/GmsAdminDashboard", element: wrapWithPermissionGuard(AdminDashboard) },
  { path: "/GmsMembership", element: wrapWithPermissionGuard(MembershipPage) },
  { path: "/GmsBilling", element: wrapWithPermissionGuard(BillingPage) },
  { path: "/GmsBillingList", element: wrapWithPermissionGuard(InvoiceListPage) },
  { path: "/GmsCustomerReceipts", element: wrapWithPermissionGuard(CustomerReceiptsPage) },
  { path: "/GmsAddReceipt", element: wrapWithPermissionGuard(AddReceiptPage) },
  { path: "/GmsCashDeposit", element: wrapWithPermissionGuard(CashDepositPage) },
  { path: "/GmsAddCashDeposit", element: wrapWithPermissionGuard(AddCashDepositPage) },
  { path: "/GmsBank", element: wrapWithPermissionGuard(BankPage) },
  { path: "/GmsBankAccount", element: wrapWithPermissionGuard(BankAccountPage) },
  { path: "/GmsDailyClosing", element: wrapWithPermissionGuard(DayClosingPage) },
  { path: "/GmsZReport", element: wrapWithPermissionGuard(ZReportPage) },
  { path: "/GmsInvoiceReport", element: wrapWithPermissionGuard(InvoiceReportPage) },
  { path: "/GmsTaxInvoiceReport", element: wrapWithPermissionGuard(TaxInvoiceReportPage) },
  { path: "/GmsBookingReport", element: wrapWithPermissionGuard(BookingReportPage) },
  { path: "/GmsEmployeeReport", element: wrapWithPermissionGuard(EmployeeReportPage) },
  { path: "/GmsDailySummary", element: wrapWithPermissionGuard(DailySummaryReportPage) },
  { path: "/GmsSourceBasedReport", element: wrapWithPermissionGuard(SourceBasedReportPage) },
  { path: "/GmsSupplier", element: wrapWithPermissionGuard(SupplierPage) },
  { path: "/GmsSupplierCategory", element: wrapWithPermissionGuard(SupplierCategoryPage) },
  { path: "/GmsPurchaseOrder", element: wrapWithPermissionGuard(PurchaseRequestPage) },
  { path: "/GmsAddPurchaseOrder", element: wrapWithPermissionGuard(AddPurchaseOrderPage) },
  { path: "/GmsPurchase", element: wrapWithPermissionGuard(PurchasePage) },
  { path: "/GmsAddPurchase", element: wrapWithPermissionGuard(AddPurchasePage) },
  { path: "/GmsStockReport", element: wrapWithPermissionGuard(StockReportPage) },
  { path: "/GmsStockTransfer", element: wrapWithPermissionGuard(StockTransferPage) },
  { path: "/GmsReceiveStockTransfer", element: wrapWithPermissionGuard(ReceiveStockTransferPage) },
  { path: "/GmsStockLockManagement", element: wrapWithPermissionGuard(StockLockManagementPage) },
  { path: "/GmsPriceCatalog", element: wrapWithPermissionGuard(PriceCatalogPage) },
  { path: "/GmsConsentForm", element: wrapWithPermissionGuard(ConsentFormPage) },
  { path: "/GmsSource", element: wrapWithPermissionGuard(SourcePage) },
  { path: "/GmsCostHead", element: wrapWithPermissionGuard(CostHeadPage) },
  { path: "/GmsOtherPayee", element: wrapWithPermissionGuard(OtherPayeePage) },
  { path: "/GmsPettyCashReceipts", element: wrapWithPermissionGuard(PettyCashPage) },
  { path: "/GmsPettyCashPayments", element: wrapWithPermissionGuard(PettyCashPage) },
  { path: "/GmsPettyCashReport", element: wrapWithPermissionGuard(PettyCashReportPage) },
  { path: "/GmsLoyaltyPoints", element: wrapWithPermissionGuard(LoyaltyPointsPage) },
  { path: "/GmsGiftCard", element: wrapWithPermissionGuard(GiftCardPage) },
  { path: "/GmsBilledServicesReport", element: wrapWithPermissionGuard(BilledServicesReportPage) },
  { path: "/GmsMessageTemplate", element: wrapWithPermissionGuard(MessageTemplatePage) },
  { path: "/GmsCustomerSegregationReport", element: wrapWithPermissionGuard(CustomerSegregationReportPage) },
  { path: "/GmsCampaignReport", element: wrapWithPermissionGuard(CampaignReportPage) },
  { path: "/GmsCampaign", element: wrapWithPermissionGuard(CampaignPage) },
  { path: "/GmsWhatsAppTest", element: <GmsWhatsAppTest /> },


]

const publicRoutes = [
  { path: "/Login", element: <Login /> },
  { path: "/logout", element: <Logout /> }
]

export { authProtectedRoutes, publicRoutes }
